import { FormattedMessage } from 'components/shared/Intl';
import { FC } from 'react';

import type { TradeDoneProps } from './trade.done.connect';

export const TradeDoneComponent: FC<TradeDoneProps> = ({ addonAction }) => {
  return (
    <div className="w-100 alert alert-discreet-info d-flex mb-0" data-e2e="trade-done">
      <div className="d-flex flex-column">
        <div className="display-5 align-middle">
          <FormattedMessage id="form.status.tradeDone" />
        </div>
        {addonAction === 'Increase' && (
          <div className="display-3 align-middle" data-e2e="you-buy">
            <FormattedMessage id="form.status.youBuy" />
          </div>
        )}
        {addonAction === 'Decrease' && (
          <div className="display-3 align-middle" data-e2e="you-sell">
            <FormattedMessage id="form.status.youSell" />
          </div>
        )}
      </div>
    </div>
  );
};

TradeDoneComponent.displayName = 'TradeDoneComponent';
